export default __webpack_public_path__ + "static/macmillan-manager-child-e897b0defe55f6ce262ea7cbfc520cce.jpg";